export default "__VITE_ASSET__ChH_VpXC__"